module.exports = __webpack_public_path__ + "img/discord.b058445e.svg";